import { render, staticRenderFns } from "./repository_required_button.vue?vue&type=template&id=2b261928&vue3"
import script from "./repository_required_button.vue?vue&type=script&lang=js&vue3"
export * from "./repository_required_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports